<script lang="ts" setup>
import '@lottiefiles/lottie-player'
import { create } from '@lottiefiles/lottie-interactivity'

const props = defineProps({
  /** src of lotiefile */
  src: {
    type: String,
    required: false
  },
  size: {
    type: String,
    default: '1em'
  },
  /** color or auto, don't change colors */
  color: {
    type: String as PropType<string|'auto'>,
    default: 'currentColor'
  },
  autoPlay: {
    type: Boolean,
    default: false
  },
  /** #id/ref of element to hover and play, or true|false, parent */
  playOnHover: {
    type: [String, Boolean, Object] as PropType<boolean|string|HTMLElement|'parent'>,
    default: false
  },
  loop: {
    type: Boolean,
    default: false
  },
  speed: {
    type: Number,
    default: 1
  }
})

const lottieElm = ref<HTMLElement|null>(null)

onMounted(function () {
  nextTick(function () {
    const shadowRoot = lottieElm?.value?.shadowRoot
    const style = document.createElement('style')
    style.textContent = `
       path{
         fill: ${props.color};
       }
      `
    shadowRoot?.appendChild(style)

    let hoverElement: HTMLElement|null = null

    if (props.playOnHover === true || props.playOnHover === '') {
      hoverElement = lottieElm?.value
    } else if (props.playOnHover === 'parent') {
      hoverElement = lottieElm?.value?.parentElement ?? null
    } else if (typeof props.playOnHover === 'string') {
      hoverElement = window.document.querySelector(props.playOnHover)
    } else if (props.playOnHover instanceof HTMLElement) {
      hoverElement = props.playOnHover
    }

    if (hoverElement) {
      create({
        mode: 'cursor',
        player: lottieElm?.value,
        container: hoverElement,
        actions: [
          {
            type: 'hold',
            forceFlag: true,
            reset: true,
            speed: props.speed
          }
        ]
      })
    }
  })
})
</script>

<template>
  <lottie-player
    id="firstLottie"
    ref="lottieElm"
    class="lottie"
    mode="normal"
    :src="props.src"
    :autoplay="props.autoPlay"
    :loop="props.loop"
    :style="`width: ${props.size}`"
    :speed="props.speed"
  >
  </lottie-player>
</template>

<style lang="scss" scoped>
  .lottie{
    width: 1em;
    height: auto;
    display: inline-block;
    overflow: hidden;
    vertical-align: -0.125em;
    fill: currentColor;
    color: v-bind("props.color");
  }

</style>
